import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n";
import { AppLayout } from "@/components/AppLayout";
import { MessageSquare, Trash2, ChevronRight, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Conversations() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get("/ai/conversations").then((r) => setItems(r.data)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, []);

  const del = async (e, sid) => { e.stopPropagation(); await api.delete(`/ai/conversations/${sid}`); load(); };

  return (
    <AppLayout>
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-display text-3xl font-semibold text-navy flex items-center gap-2"><MessageSquare className="h-7 w-7 text-brandblue" /> {t("conversations_title")}</h1>
          <p className="mt-1 text-slate-500">{t("conversations_sub")}</p>
        </div>
        <Button data-testid="new-chat-btn" onClick={() => navigate("/chat")} className="rounded-full brand-gradient text-white"><Plus className="h-4 w-4 mr-1" />{t("new_chat")}</Button>
      </div>

      <div className="mt-6 space-y-3">
        {loading && <p className="text-sm text-slate-400">{t("loading")}</p>}
        {!loading && items.length === 0 && (
          <div className="rounded-2xl border border-dashed border-slate-200 p-10 text-center text-slate-400">
            {t("no_conversations")} <button onClick={() => navigate("/chat")} className="text-brandblue font-medium">{t("start_one")}</button>
          </div>
        )}
        {items.map((c) => (
          <div key={c.session_id} data-testid={`conv-${c.session_id}`} role="button" tabIndex={0}
            onClick={() => navigate("/chat", { state: { sessionId: c.session_id } })}
            onKeyDown={(e) => { if (e.key === "Enter") navigate("/chat", { state: { sessionId: c.session_id } }); }}
            className="flex w-full items-center gap-4 rounded-2xl bg-white border border-slate-100 card-shadow p-4 text-left cursor-pointer hover:shadow-md transition-shadow">
            <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-blue-50 text-brandblue"><MessageSquare className="h-5 w-5" /></span>
            <div className="flex-1 min-w-0">
              <p className="font-medium text-navy truncate">{c.title}</p>
              <p className="text-xs text-slate-400 truncate">{c.count} {c.count === 1 ? t("message") : t("messages")} · {new Date(c.last).toLocaleString()}</p>
            </div>
            <button onClick={(e) => del(e, c.session_id)} data-testid={`conv-del-${c.session_id}`} className="rounded-full p-2 text-slate-300 hover:text-red-500 hover:bg-red-50"><Trash2 className="h-4 w-4" /></button>
            <ChevronRight className="h-5 w-5 text-slate-300" />
          </div>
        ))}
      </div>
    </AppLayout>
  );
}
